import React, { useState, useRef, useEffect } from "react";
import { RCCHookToast, RCCIcon } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import Title from "../Title";
import { IEditableTitle } from "./interface";
import InputStyled from "./styles";

const PencilIcon = <RCCIcon 
	name="pencil"
	color="rgba(0,0,0,0.35)"
	style={{
		transform: "scale(0.8)",
		marginRight: "2px"
	}}
/>;

const EditableTitle: React.FC<IEditableTitle> = ({
	value,
	titleProps,
	onSubmit,
	colorBorderInput,
	heightInput,
	disabled,
	maxLength,
	placeholder,
	required = true,
	resize = true,
	pencilIcon = true
}) => {
	const { addToast } = RCCHookToast();
	const { translate } = useTranslation();
	const [isEditableTitle, setIsEditableTitle] = useState(false);
	const refInput = useRef<HTMLTextAreaElement>(null);
   
	const resetEdit = () => {
		setIsEditableTitle(false);
		document.removeEventListener("mousedown", handleClickOutside);
	};

	const setEdit = () => {
		if (isEditableTitle)
			return;
            
		setIsEditableTitle(true);
		document.addEventListener("mousedown", handleClickOutside);
	};

	const executeOnSuccess = async (val: string) => {
		if(val === value || (required && val.trim() === "")){
			resetEdit();
			return;
		}

		try{
			await onSubmit(val);
			resetEdit();
		}catch(err){
			standardErrorMessages(err, translate("Erro ao alterar campo"), addToast);
		}
	};

	const handleKeyDown = (ref: any) => {
		if(ref.key === "Enter") {
			executeOnSuccess(ref.target.value);
		}
	};

	const handleClickOutside = (event: any) => {
		if (refInput.current && !refInput.current.contains(event.target)) {
			executeOnSuccess(refInput.current?.value);
		}
	};

	// eslint-disable-next-line arrow-body-style
	useEffect(() => {
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<>
			{disabled ? 
				<Title 
					color="purple" 
					{...titleProps}
				> 
					{value !== null && value.length > 0 ? value : placeholder} 
				</Title> 
				: 
				<>
					{isEditableTitle ? <InputStyled 
						autoFocus
						onKeyDown={handleKeyDown} 
						defaultValue={value || ""} 
						color={colorBorderInput}
						ref={refInput} 
						heightInput={heightInput}
						maxLength={maxLength}
						placeholder={placeholder}
						resize={resize}
					/> : 
						<Title 
							color="purple" 
							{...titleProps}
							onClick={() => setEdit()}
						> {pencilIcon ? PencilIcon : null} {value !== null && value.length > 0 ? value : placeholder} </Title>
					}
				</>}
		</>
	);
};

export default EditableTitle;
